import { useEffect, useRef, useState } from 'react';
import { Main } from '../../styled';
import { Row, Col, Form, Modal, Input } from 'antd';
import {
  getPmsData,
  getPmsAuth,
  postPartnerDetails,
  getPartnerDetails,
  otpSendingToEmail,
  emailVerification,
} from '../../../redux/managePms/actionCreator';
import { useDispatch } from 'react-redux';
import Spinner from '../../common/Spinner';
import Notification from '../../../utility/notification';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { AddUser } from '../style';
import HttpStatus from '../../../utility/status.enum';
import { useParams } from 'react-router-dom';
import { getProfile } from '../../../redux/userProfile/actionCreator';
import { useCMS } from '../../../utility/useCMS.js';

const ManagePMS = () => {
  const { hostLoginRoleID, adminLoginRoleID } = global;
  const hostSlug = useParams()?.hostSlug ?? '';
  const dispatch = useDispatch();
  const [TrackForm] = Form.useForm();
  const [GuestyForm] = Form.useForm();
  const [StreamLineForm] = Form.useForm();
  const [LodgifyForm] = Form.useForm();
  const [HostawayForm] = Form.useForm();
  const [HospitablePATForm] = Form.useForm();

  const [pmsList, setPmsList] = useState();
  const [spinnerLoader, setSpinnerLoader] = useState(true);
  const [loginUser, setLoginUser] = useState([]);
  const connectedCtaIndex = useRef([]);
  const [showTrackModal, setShowTrackModal] = useState(false);
  const [trackCtaButton, setTrackCtaButton] = useState('Save');
  const [showGuestyModal, setShowGuestyModal] = useState(false);
  const [requestType, setRequestType] = useState(0); // 1 - Track PMS, 2 - Guesty PMS
  const updateCtaIndex = useRef([]);
  const [clickedPmsSlug, setclickedPmsSlug] = useState('');
  const [showStreamlineModal, setShowStreamlineModal] = useState(false);
  const [streamlineCtaButton, setStreamlineCtaButton] = useState('Save');
  const [isPopupPms, setIsPopupPms] = useState(false); // to manage the pop up button disable
  const [pmsPartnerId, setPmsPartnerId] = useState(null);
  const [isReloadRequired, setIsReloadRequired] = useState(false);
  const [otpVerifyForm] = Form.useForm();
  const [showLodgifyModal, setShowLodgifyModal] = useState(false);
  const [lodgifyCtaButton, setLodgifyCtaButton] = useState('Save');
  const [showHostawayModal, setShowHostawayModal] = useState(false);
  const [hostawayCtaButton, setHostawayCtaButton] = useState('Save');
  const [showHospitablePATModal, setShowHospitablePATModal] = useState(false);
  const [HospitablePATButton, setHospitablePATButton] = useState('Save');
  const { fetchCMSCommonFunction } = useCMS();
  const [cmsContentDescription, setCmsContentDescription] = useState([]);
  const [clickedConfigSlug, setClickedConfigSlug] = useState(null); // Tracks the specific account slug for reconnect/update


  const PARTNER_TYPE = {
    OWNERREZ: 1,
    HOSPITABLE: 2,
    TRACK: 3,
    GUESTY: 4,
    STREAMLINE: 5,
    HOSTAWAY: 6,
    CLOUDBEDS: 7,
    LODGIFY: 8,
  };

  const STATUS = {
    NOT_CONNECT: 0,
    ACTIVE: 1,
    PENDING: 2,
    ERROR: 3,
  };

  const REQUEST_TYPE = {
    TRACK: 1,
    GUESTY: 2,
    STREAMLINE: 3,
    HOSTAWAY: 4,
    LODGIFY: 5,
    HOSPITABLE: 6,
  }

  useEffect(() => {
    const getUser = JSON.parse(localStorage.getItem('user'));
    if (getUser) {
      setLoginUser(getUser);
    }

    fetchCMSCommonFunction(23).then((description) => {
      setCmsContentDescription(description);
    });
  }, []);

  useEffect(() => {
    const fetchPmsData = async () => {
      setSpinnerLoader(true);
      try {
        const parms = hostSlug ? '?host_slug=' + hostSlug : '';
        const pmsResult = await dispatch(getPmsData(parms));
        setPmsList(pmsResult);
      } catch (error) {
        console.log('Error in fetching PMS data', error);
      } finally {
        setSpinnerLoader(false);
      }
    };
    fetchPmsData();
  }, [isReloadRequired, hostSlug]);

  const createPmsAuth = async (pmsSlug, configSlug = null) => {

    setSpinnerLoader(true);
    let hostSlugValue = "";
    if(loginUser?.role_id === adminLoginRoleID) {
      hostSlugValue = hostSlug;
    } else if(loginUser?.role_id === hostLoginRoleID) {
      hostSlugValue = loginUser?.slug;
    }
    const form = {
      pms_slug: pmsSlug,
      host_slug: hostSlugValue,
      ...(configSlug && { config_slug: configSlug }), // Include config_slug for reconnect to identify the specific account
    };
    try {
      const pmsResult = await dispatch(getPmsAuth(form));
      const { result, message } = pmsResult;
      // If already connect PMS found
      if (result?.status_id === STATUS.ACTIVE) {
        connectedCtaIndex.current = [...connectedCtaIndex.current, pmsSlug];
        Notification.addNotificationError(message); // showing appropriate message
        setIsReloadRequired((prev) => !prev);
      } else if (result?.url) { // If already not connected then
        window.open(result?.url, '_blank', 'noopener,noreferrer'); // open in new tab
        global.isOAuthFlowTrigger = true;
      }
    } catch (error) {
      console.log('Error in createPmsAuth API', error);
    } finally {
      setSpinnerLoader(false);
    }
  };

  // After submit credentials in popup
  const savePmsDetails = (values) => {
    // Function to check if any value is empty or contains only spaces
    const isInvalidValue = (value) => {
      return value && value.trim() === '';
    };

    // Check for any invalid values in the input
    for (let key in values) {
      if (isInvalidValue(values[key])) {
        return; // Stop if any invalid value is found
      }
    }

    let hostSlugValue = "";
    if(loginUser?.role_id === adminLoginRoleID) {
      hostSlugValue = hostSlug;
    }

    let requestData = { request_type: requestType, host_slug: hostSlugValue, ...(clickedConfigSlug && { config_slug: clickedConfigSlug }), ...values };

    const postPMSCredentials = async () => {
      try {
        setSpinnerLoader(true);
        const apiResponse = await dispatch(
          postPartnerDetails(requestData, (response) => {
            return response;
          }),
        );
        if (apiResponse?.status === HttpStatus.HTTP_OK) {
          Notification.addNotificationSuccess(apiResponse.message);
          if (isPopupPms) {
            updateCtaIndex.current = [...updateCtaIndex.current, clickedPmsSlug]; // for controlling updated cta title after success
          } else {
            connectedCtaIndex.current = [...connectedCtaIndex.current, clickedPmsSlug]; // for controlling connected cta title button after success.
          }
          hidePmsPopup(); // hide the modal after success
          if([REQUEST_TYPE.STREAMLINE, REQUEST_TYPE.TRACK, PARTNER_TYPE.OWNERREZ, PARTNER_TYPE.HOSPITABLE, REQUEST_TYPE.GUESTY, PARTNER_TYPE.CLOUDBEDS, REQUEST_TYPE.HOSTAWAY, REQUEST_TYPE.LODGIFY].includes(requestType)) {
            const profileResponse = await dispatch(getProfile()); // call profile api for import from PMS sync button on managelisting
            if (profileResponse?.status === HttpStatus.HTTP_OK) {
              global.importFromListingFlag = profileResponse?.result?.is_import_from_pms_enable;
            }
          }
        } else {
          Notification.addNotificationError(apiResponse.message);
        }
        setIsReloadRequired((prev) => !prev);
      } catch (error) {
      } finally {
        setSpinnerLoader(false);
      }
    };
    postPMSCredentials();
  };

  const checkValidation = () => {
    setTimeout(() => {
      const errorElements = document.querySelectorAll('.ant-form-item-has-error');
      if (errorElements.length > 0) {
        const firstErrorElement = errorElements[0] ?? 0;
        firstErrorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start',
        });
      }
    }, 300);
  };

  const hidePmsPopup = () => {
    setShowTrackModal(false); // hide the track modal
    setShowGuestyModal(false); // hide the guesty model
    setShowStreamlineModal(false); // hide the streamline modal
    setShowHostawayModal(false); // hide the hostaway modal
    setShowLodgifyModal(false); // hide the lodgify modal
    setShowHospitablePATModal(false); // hide the hospitable
    TrackForm.resetFields();
    GuestyForm.resetFields();
    StreamLineForm.resetFields();
    HostawayForm.resetFields();
    LodgifyForm.resetFields();
    HospitablePATForm.resetFields();
    setIsPopupPms(false); // reset the popup button state
    setClickedConfigSlug(null); // reset the config slug for the next interaction
  };

  const getPartnerDetail = async (partnerTypeId, configSlug = null) => {
    setSpinnerLoader(true); // Show loading spinner while fetching data
    try {
      // Determine request_type based on partner type
      let getRequestType = 0;
      if (partnerTypeId === PARTNER_TYPE.TRACK) {
        getRequestType = REQUEST_TYPE.TRACK;
      } else if (partnerTypeId === PARTNER_TYPE.STREAMLINE) {
        getRequestType = REQUEST_TYPE.STREAMLINE;
      } else if (partnerTypeId === PARTNER_TYPE.LODGIFY) {
        getRequestType = REQUEST_TYPE.LODGIFY;
      } else if (partnerTypeId === PARTNER_TYPE.HOSTAWAY) {
        getRequestType = REQUEST_TYPE.HOSTAWAY;
      } else if (partnerTypeId === PARTNER_TYPE.HOSPITABLE) { // add hospitable PAT Token
        getRequestType = REQUEST_TYPE.HOSPITABLE;
      }
      let hostSlugValue = "";
      if(loginUser?.role_id === adminLoginRoleID) {
        hostSlugValue = hostSlug;
      }
      const payload = { request_type: getRequestType, host_slug: hostSlugValue, ...(configSlug && { config_slug: configSlug }) };
      // Fetch partner details from API
      const partnerDetails = await dispatch(getPartnerDetails(payload));

      // If API call is successful
      if (partnerDetails?.status === HttpStatus.HTTP_OK) {
        const result = partnerDetails?.result || {};

        // Populate Streamline PMS form and set button label
        if (partnerTypeId === PARTNER_TYPE.STREAMLINE) {
          // Streamline PMS
          StreamLineForm.setFieldsValue({
            client_secret: result.client_secret || '',
            client_id: result.client_id || '',
          });
          setStreamlineCtaButton('Update');
        }
        // Populate Track PMS form and set button label
        else if (partnerTypeId === PARTNER_TYPE.TRACK) {
          // Track PMS
          TrackForm.setFieldsValue({
            client_url: result.client_url || '',
            client_id: result.client_id || '',
            client_secret: result.client_secret || '',
          });
          setTrackCtaButton('Update');
        }
        // Populate Hostaway PMS form and set button label
        else if (partnerTypeId === PARTNER_TYPE.HOSTAWAY) {
          // Hostaway PMS
          HostawayForm.setFieldsValue({
            client_id: result.client_id || '',
            client_secret: result.client_secret || '',
          });
          setHostawayCtaButton('Update');
        }
        // Populate Lodgify PMS form and set button label
        else if (partnerTypeId === PARTNER_TYPE.LODGIFY) {
          // Lodgify PMS
          LodgifyForm.setFieldsValue({
            client_secret: result.client_secret || ''
          });
          setLodgifyCtaButton('Update');
        }
        // Populate Hospitable PMS form and set button label
        else if (partnerTypeId === PARTNER_TYPE.HOSPITABLE) {
          // If hospitable pat token exits
          if (result.client_secret) {
            HospitablePATForm.setFieldsValue({
              client_secret: result.client_secret || ''
            });
            setHospitablePATButton('Update');
          } else {  // If hospitable pat token not exits
            setHospitablePATButton('Save');
            HospitablePATForm.resetFields();
          }
        }

        // If API call fails or no data, reset forms and set button to 'Save'
      } else if (partnerTypeId === PARTNER_TYPE.STREAMLINE) {
        // Streamline PMS
        setStreamlineCtaButton('Save');
        StreamLineForm.resetFields();
      } else if (partnerTypeId === PARTNER_TYPE.TRACK) {
        setTrackCtaButton('Save');
        TrackForm.resetFields();
      } else if (partnerTypeId === PARTNER_TYPE.LODGIFY) {
        setLodgifyCtaButton('Save');
        LodgifyForm.resetFields();
      } else if (partnerTypeId === PARTNER_TYPE.HOSTAWAY) {
        setHostawayCtaButton('Save');
        HostawayForm.resetFields();
      } else if (partnerTypeId === PARTNER_TYPE.HOSPITABLE) {
        setHospitablePATButton('Save');
        HospitablePATForm.resetFields();
      }
    } catch (error) {
      console.log('Error in fetching PMS data', error);
    } finally {
      setSpinnerLoader(false);
    }
  };

  const pmsBtnClicked = (pmsSlug, partnerTypeId, configSlug = null) => {
    setclickedPmsSlug(pmsSlug); // store the clicked PMS slug for updating cta title
    setClickedConfigSlug(configSlug); // store config_slug to identify the specific account (null for new connections)

    // oAuth Flow
    if ([PARTNER_TYPE.OWNERREZ, PARTNER_TYPE.HOSPITABLE, PARTNER_TYPE.CLOUDBEDS].includes(partnerTypeId)) {
      // 1 - OwnerRez , 2 - Hospitable and 7 - Cloudbeds
      createPmsAuth(pmsSlug, configSlug);
      setIsPopupPms(false); // reset the popup button state
      return; // exit the function after creating auth
    }

    // API Flow
    if (partnerTypeId === PARTNER_TYPE.TRACK) {
      setRequestType(REQUEST_TYPE.TRACK);
      setIsPopupPms(configSlug !== null); // populate form only when reconnecting an existing account
      getPartnerDetail(PARTNER_TYPE.TRACK, configSlug);
      setShowTrackModal(true);
      return;
    }

    // API Flow
    if (partnerTypeId === PARTNER_TYPE.GUESTY) {
      setRequestType(REQUEST_TYPE.GUESTY); // request type send to api
      setShowGuestyModal(true); // show the modal for guesty PMS
      setIsPopupPms(false); // reset the popup button state (Not for update details)
      return; // exit the function after showing guesty modal
    }

    // API Flow
    if (partnerTypeId === PARTNER_TYPE.STREAMLINE) {
      setRequestType(REQUEST_TYPE.STREAMLINE);
      setIsPopupPms(configSlug !== null); // populate form only when reconnecting an existing account
      getPartnerDetail(PARTNER_TYPE.STREAMLINE, configSlug);
      setShowStreamlineModal(true);
      return;
    }

    // API Flow
    if (partnerTypeId === PARTNER_TYPE.LODGIFY) {
      setRequestType(REQUEST_TYPE.LODGIFY);
      setIsPopupPms(configSlug !== null); // populate form only when reconnecting an existing account
      getPartnerDetail(PARTNER_TYPE.LODGIFY, configSlug);
      setShowLodgifyModal(true);
      return;
    }
    
    // API Flow
    if (partnerTypeId === PARTNER_TYPE.HOSTAWAY) {
      setRequestType(REQUEST_TYPE.HOSTAWAY); // request type sent to API
      setIsPopupPms(configSlug !== null); // populate form only when reconnecting an existing account
      getPartnerDetail(PARTNER_TYPE.HOSTAWAY, configSlug); // fetch Hostaway partner details
      setShowHostawayModal(true); // show Hostaway modal
      return; // exit function after showing modal
    }
  };

    // handle Hospitable PAT Token Flow — configSlug identifies the specific Hospitable account
    const handleHospitablePATClick = (configSlug = null) => {
      setClickedConfigSlug(configSlug);
      getPartnerDetail(PARTNER_TYPE.HOSPITABLE, configSlug);
      setShowHospitablePATModal(true);
      setRequestType(REQUEST_TYPE.HOSPITABLE);
    };

  return (
    <>
    <Cards xs={24} headless className='borderRadius common_fiter_table'>
      <Main className="inbox-container pms-container">
        <Row gutter={15}>
          <Col xs={24}>
            <Cards headless>
              <Spinner loader={spinnerLoader} />
              <Row gutter={15}>
                {pmsList &&
                  pmsList.map((item, index) => {
                    const editablePartners = [
                      PARTNER_TYPE.TRACK,
                      PARTNER_TYPE.STREAMLINE,
                      PARTNER_TYPE.HOSTAWAY,
                      PARTNER_TYPE.LODGIFY,
                    ];

                    const hasAccounts = item.accounts && item.accounts.length > 0;
                    const displayAccounts = hasAccounts ? item.accounts : [];
                    const isGuesty = item.partner_type_id === PARTNER_TYPE.GUESTY;
                    const hasGuestyAccounts = isGuesty && item.accounts && item.accounts.length > 0;

                    return (
                      <Col xs={24} md={8} lg={6} key={index} className ="pl-0 pr-0">
                        <div className="pms-card pms-card-mockup">
                          <div className="pms-imgBox">
                            <img
                              src={item.pms_logo || require('../../../static/img/pms_placeholder_img.png')}
                              alt={item.name}
                              className={`pms-img ${!item.pms_logo ? 'placeholder-pms-img' : ''}`}
                            />
                          </div>

                          <div className="pms-card-btn pms-card-btn-mockup">
                            {displayAccounts.length > 0 ? (
                              <div className="pms-account-list">
                                {displayAccounts.map((account, accIndex) => {
                                  const isAccountActive = account.connected_status_id === STATUS.ACTIVE;
                                  const isAccountError = account.connected_status_id === STATUS.ERROR;
                                  const isHospitablePAT = item.partner_type_id === PARTNER_TYPE.HOSPITABLE && item.show_pat_button;
                                  const isEditablePartner = editablePartners.includes(item.partner_type_id);

                                  return (
                                    <div className="pms-account-row" key={account.config_slug || accIndex}>
                                      <span className="pms-account-name">{account?.listing_count}</span>

                                      <div className="pms-account-actions">
                                        {isHospitablePAT ? (
                                          <>
                                            {isAccountActive ? (
                                              <button
                                                className="pms-account-btn disable-style-btn"
                                                disabled
                                              >
                                                Connected
                                              </button>
                                            ) : isAccountError ? (
                                              <button
                                                className="pms-account-btn"
                                                onClick={() =>
                                                  pmsBtnClicked(item.slug, item.partner_type_id, account.config_slug)
                                                }
                                              >
                                                Reconnect
                                              </button>
                                            ) : (
                                              <button
                                                className="pms-account-btn"
                                                onClick={() =>
                                                  pmsBtnClicked(item.slug, item.partner_type_id, account.config_slug)
                                                }
                                              >
                                                Connect
                                              </button>
                                            )}

                                            <button
                                              className="pms-account-btn"
                                              onClick={() => handleHospitablePATClick(account.config_slug)}
                                            >
                                              {account.has_pat_token ? 'Update a Mini App' : 'Add a Mini App'}
                                            </button>
                                          </>
                                        ) : isEditablePartner && isAccountActive ? (
                                          <button
                                            className="pms-account-btn pms-account-btn--update"
                                            onClick={() =>
                                              pmsBtnClicked(item.slug, item.partner_type_id, account.config_slug)
                                            }
                                          >
                                            Update Details
                                          </button>
                                        ) : isAccountError ? (
                                          <button
                                            className="pms-account-btn"
                                            onClick={() =>
                                              pmsBtnClicked(item.slug, item.partner_type_id, account.config_slug)
                                            }
                                          >
                                            Reconnect
                                          </button>
                                        ) : isAccountActive ? (
                                          <button
                                            className="pms-account-btn disable-style-btn"
                                            disabled
                                          >
                                            Connected
                                          </button>
                                        ) : (
                                          <button
                                            className="pms-account-btn"
                                            onClick={() =>
                                              pmsBtnClicked(item.slug, item.partner_type_id, account.config_slug)
                                            }
                                          >
                                            Connect
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <div className="pms-account-list empty-account-list" />
                            )}

                            <button
                              className={`pms-button pms-main-btn ${hasGuestyAccounts ? 'disabled-btn' : ''}`}
                              disabled={hasGuestyAccounts}
                              onClick={() => pmsBtnClicked(item.slug, item.partner_type_id)}
                            >
                              {item?.cta_button || 'Connect New'}
                            </button>
                          </div>
                        </div>
                      </Col>

                    );
                  })}
              </Row>
            </Cards>
          </Col>
        </Row>
      </Main>

      <Modal
        type="primary"
        open={showTrackModal}
        title={`${trackCtaButton == 'Save' ? 'Add' : 'Update'} Details`}
        footer={null}
        onCancel={hidePmsPopup}
        className='security-hold-modal'
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={TrackForm} name="trackDetails" onFinish={savePmsDetails}>
                <Row gutter={15} className="mt-5">
                  <div className="custom_editor_span_text" dangerouslySetInnerHTML={{ __html: cmsContentDescription?.trackhs_help_text }} />
                  <Col xs={24} md={24}>
                    <Form.Item
                      className='mt-20'
                      label="Client URL"
                      name="client_url"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter client url',
                          transform: (value) => value?.trim(),
                        },
                        {
                          type: 'url',
                          message: 'Please enter valid client url',
                        },
                      ]}
                    >
                      <Input placeholder="Enter client url" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24} md={24}>
                    <Form.Item
                      label="Client Id"
                      name="client_id"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter client Id',
                          transform: (value) => value?.trim(),
                        },
                      ]}
                    >
                      <Input placeholder="Enter client Id" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24} md={24}>
                    <Form.Item
                      label="Client Secret"
                      name="client_secret"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter client secret',
                          transform: (value) => value?.trim(),
                        },
                      ]}
                    >
                      <Input placeholder="Enter client secret" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button
                      htmlType="submit"
                      size="default"
                      type="dark"
                      shape="circle"
                      key="submit"
                      className="w-100"
                      onClick={checkValidation}
                    >
                      {trackCtaButton}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>

      <Modal
        type="primary"
        open={showGuestyModal}
        title="Add Details"
        footer={null}
        onCancel={hidePmsPopup}
        className='security-hold-modal'
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={GuestyForm} name="trackDetails" onFinish={savePmsDetails}>
                <Row gutter={15} className="mt-5">
                  <div className="custom_editor_span_text" dangerouslySetInnerHTML={{ __html: cmsContentDescription?.guesty_help_text }} />
                  <Col xs={24} md={24}>
                    <Form.Item
                      className='mt-20'
                      label="Integration Token"
                      name="client_secret"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter integration token',
                          transform: (value) => value?.trim(),
                        },
                      ]}
                    >
                      <Input placeholder="Paste integration token here" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button
                      htmlType="submit"
                      size="default"
                      type="dark"
                      shape="circle"
                      key="submit"
                      className="w-100"
                      onClick={checkValidation}
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>
      <Modal
        type="primary"
        title={`${streamlineCtaButton == 'Save' ? 'Add' : 'Update'} Details`}
        open={showStreamlineModal}
        footer={null}
        onCancel={hidePmsPopup}
        className='security-hold-modal'
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={StreamLineForm} name="streamlineDetails" onFinish={savePmsDetails}>
                <Row gutter={15} className="mt-5">
                  <div className="custom_editor_span_text" dangerouslySetInnerHTML={{ __html: cmsContentDescription?.streamline_help_text }} />
                  <Col xs={24} md={24}>
                    <Form.Item
                      className='mt-20'
                      label="Token Key"
                      name="client_id"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter token key',
                          transform: (value) => value?.trim(),
                        },
                      ]}
                    >
                      <Input placeholder="Enter token key" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24} md={24}>
                    <Form.Item
                      label="Token Secret"
                      name="client_secret"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter token secret',
                          transform: (value) => value?.trim(),
                        },
                      ]}
                    >
                      <Input placeholder="Enter token secret" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button htmlType="submit" size="default" type="dark" shape="circle" key="submit" className="w-100">
                      {streamlineCtaButton}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>

      <Modal
        type="primary"
        title={`${hostawayCtaButton === 'Save' ? 'Add' : 'Update'} Details`}
        open={showHostawayModal}
        footer={null}
        onCancel={hidePmsPopup}
        maskClosable={false}
        aria-hidden="false"
        className='security-hold-modal'
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={HostawayForm} name="hostawayDetails" onFinish={savePmsDetails}>
                <Row gutter={15} className="mt-5">
                  <div className="custom_editor_span_text" dangerouslySetInnerHTML={{ __html: cmsContentDescription?.hostaway_help_text }} />
                  <Col xs={24} md={24}>
                    <Form.Item
                      className='mt-20'
                      label="Client Id"
                      name="client_id"
                      rules={[
                        {
                          required: true,
                          message: 'Enter client Id',
                          transform: (value) => value?.trim(),
                        },
                      ]}
                    >
                      <Input placeholder="Enter client Id" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24} md={24}>
                    <Form.Item
                      label="Client Secret"
                      name="client_secret"
                      rules={[{ required: true, message: 'Please enter client secret', transform: (value) => value?.trim() }]}
                    >
                      <Input placeholder="Enter client secret" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button
                      htmlType="submit"
                      size="default"
                      type="dark"
                      shape="circle"
                      className="w-100"
                    >
                      {hostawayCtaButton}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>
      <Modal
        type="primary"
        title={`${lodgifyCtaButton === 'Save' ? 'Add' : 'Update'} Details`}
        open={showLodgifyModal}
        footer={null}
        onCancel={hidePmsPopup}
        maskClosable={false}
        aria-hidden="false"
        className='security-hold-modal'
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={LodgifyForm} name="lodgifyDetails" onFinish={savePmsDetails}>
                <Row gutter={15} className="mt-15">
                  <div className="custom_editor_span_text" dangerouslySetInnerHTML={{ __html: cmsContentDescription?.lodgify_help_text }} />
                  <Col xs={24} md={24}>
                    <Form.Item
                      className='mt-20'
                      label="API Key"
                      name="client_secret"
                      rules={[{ required: true, message: 'Please enter your API Key', transform: (value) => value?.trim() }]}
                    >
                      <Input placeholder="Please enter your API Key" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button
                      htmlType="submit"
                      size="default"
                      type="dark"
                      shape="circle"
                      className="w-100"
                    >
                      {lodgifyCtaButton}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>
       <Modal
        type="primary"
        title={`${HospitablePATButton === 'Save' ? 'Add' : 'Update'} a Mini App`}
        open={showHospitablePATModal}
        footer={null}
        onCancel={hidePmsPopup}
        maskClosable={false}
        aria-hidden="false"
        className='security-hold-modal'
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={HospitablePATForm} name="HospitablePATToken" onFinish={savePmsDetails}>
                <Row gutter={15} className="mt-15">
                  <div className="custom_editor_span_text" dangerouslySetInnerHTML={{ __html: cmsContentDescription?.hospitable_pat }} />
                  <Col xs={24} md={24}>
                    <Form.Item
                      className='mt-20'
                      label="Add a Mini App"
                      name="client_secret"
                      rules={[{ required: true, message: 'Please enter your UID/Secret Key/ Token', transform: (value) => value?.trim(), }]}
                    >
                      <Input placeholder="Enter your UID/Secret Key/ Token" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button
                      htmlType="submit"
                      size="default"
                      type="dark"
                      shape="circle"
                      className="w-100"
                    >
                      {HospitablePATButton}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>
    </Cards>
    </>
  );
};

export default ManagePMS;
